import { createSlice } from "@reduxjs/toolkit";

export const bulkCallsSlice = createSlice({
    name: "bulkCallsForLeadGen",
    initialState: {
        isBulkCallsEnabled: false,
    },
    reducers: {
        setIsBulkCallsEnabled: (state, action) => {
            state.isBulkCallsEnabled = action.payload;
        }
    }
})

export const { setIsBulkCallsEnabled } = bulkCallsSlice.actions;

export default bulkCallsSlice.reducer;